<pdq-paginated-batch-table
  [state]="batchesState"
  [totalCount]="totalCount"
  [countLoading]="countLoading"
  [title]="title"
  [columns]="columns"
  [allowReorder]="allowReorder"
  [bulkSelectEnabled]="!!fulfillBatchBulkActions()?.enabled"
  [maxSelectedOrders]="fulfillBatchBulkActions()?.maxOrders ?? null"
  [bulkActions]="bulkActions"
  [carrierOptions]="carriers"
  [locationOptions]="locations()"
  [ownerOptions]="owners"
  (onLoadPage)="onLoadPage($event)"
  (onFilterChange)="onFilterChange($event)"
  (onPageSizeChange)="onPageSizeChange($event)"
  (onRowClick)="onRowClick($event)"
  (onBatchReorder)="onBatchReorder($event)">
</pdq-paginated-batch-table>
